import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './components/Navbar/Navbar';
import Content from './components/Content/Content';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { LanguageProvider } from './i18n/LanguageContext';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-gray-50">
          <Navbar />
          <Content />
          <Footer />
          <CookieConsent />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default App;
